define('app/config.js',[],function(){
	function config($routeProvider, $locationProvider) {
			$locationProvider.html5Mode(false).hashPrefix('');
    	$routeProvider.when('/', {
			templateUrl: 'app/components/dashboard/dashboardView.html',
			controller: 'dashboardController'					
		})
		.when('/drivers', {
			templateUrl: 'app/components/drivers/driversView.html',
			controller: 'driversController'					
		})
		.when('/constructors', {
			templateUrl: 'app/components/constructors/constructorsView.html',
			controller: 'constructorsController'					
		})
		.when('/races/:name?', {
			templateUrl: 'app/components/race/raceView.html',
			controller: 'raceController'					
		})
		.otherwise({
			templateUrl: 'app/components/dashboard/dashboardView.html',
			controller: 'dashboardController'
		})
	}
  	config.$inject=['$routeProvider', '$locationProvider'];

  	return config;
});
